export const brandTokens = {
  tekheletPurple40: '#4A35A3',
  tekheletPurple30: '#5840C1',
  tekheletPurple20: '#735FCB',
  tekheletPurple10: '#8E7DD5',
  tekheletPurple5: '#9C8DDA',
  tekheletPurple1: '#AB9EDF',
  tekheletPurple: '#160F2F',

  royalPurple80: '#351E53',
  royalPurple60: '#6B47A3',
  royalPurple50: '#8657C2',
  royalPurple40: '#9C75CD',
  royalPurple30: '#B193D8',
  royalPurple5: '#E7DEF3',
  royalPurple1: '#EFE9F6',
  royalPurple: '#FAF7FF',
}
